import React, { Component } from 'react';
import _ from 'lodash';
import { Form, Grid, Header } from 'semantic-grab-ui/src';
import { ActionForm, TridentCampaignDetails } from '../../../types/trident-campaigns';
import { isValidJSON } from './util';

import FormInputWithError from '../FormInputWithError';
import formComponent from '../../decorators/form_component';

interface Props {
  model: TridentCampaignDetails;
  onModelChange: (model: TridentCampaignDetails) => void;
  actionForm: ActionForm;
  handleInputChange: (event: any, data: { name: string; value: any }) => void;
  handleControlBlur: (event: any) => void;
  currentNode: string;
  subActionIndex: number;
}

interface InputFieldConfig {
  label: string;
  type: string;
  isRequired: boolean;
  payloadPath: string;
  dropdownList?: Array<{ value: string; text: string }>;
}

@formComponent()
export default class AutoGeneratedActionForm extends Component<Props> {
  handleInputChange = (name: string, event: any, data?: any, fieldType?: string) => {
    // For dropdowns, data is passed, for text inputs, event is passed
    const fieldValue = data ? data.value : event.target.value;

    let parsedValue: any = fieldValue;

    // If the field value is a valid JSON, parse it
    const isJsonObject = isValidJSON(fieldValue);
    if (isJsonObject) {
      parsedValue = JSON.parse(fieldValue);
    } else if (fieldType === 'number' && fieldValue.trim() !== '') {
      // Only convert to number if the field type is explicitly "number"
      const numericValue = Number(fieldValue);
      if (!isNaN(numericValue) && isFinite(numericValue)) {
        parsedValue = numericValue;
      }
    }

    this.props.handleInputChange({}, {
      name,
      value: parsedValue,
    });
  };

  render() {
    const { actionForm } = this.props;
    const inputFields = _.get(actionForm, 'fields', []);
    const header = _.get(actionForm, 'header');

    return (
      <React.Fragment>
        {header && <Header.Subheader style={{ marginBottom: 20 }}>
          {header}
        </Header.Subheader>}

        <Form>
          <Grid>
            {inputFields.map((inputFieldConfig: InputFieldConfig, index: number) => this.constructInputField(inputFieldConfig, index, this.props))}
          </Grid>
        </Form>
      </React.Fragment>
    );
  }

  constructInputField = (inputFieldConfig: InputFieldConfig, rowIndex: number, props: Props) => {
    const { handleControlBlur, model, currentNode, subActionIndex } = props;
    const { label, type, isRequired, payloadPath, dropdownList } = inputFieldConfig;

    const options = _.isArray(dropdownList) ? dropdownList.map(dropdownItem => ({
      key: dropdownItem.value,
      text: dropdownItem.text,
      value: dropdownItem.value,
    })) : [];

    const name = `nodes.${currentNode}.data.${subActionIndex}.meta.${payloadPath}`;
    const isDropdown = (options.length > 0);
    const FormInputComponent = isDropdown ? Form.Select : Form.Input;

    let value = _.get(model, name);
    const isJsonValue = typeof value === 'object' && value !== null;
    if (isJsonValue) {
      // Convert Json objects to display it in string
      value = JSON.stringify(value, null, 2);
    }

    return (<Grid.Row key={rowIndex}>
      <Grid.Column width={isDropdown ? 4 : 8}>
        <FormInputWithError
          name={name}
          {...this.props}
        >
          <FormInputComponent
            label={label}
            required={isRequired}
            options={isDropdown ? options : undefined}
            type={!isDropdown ? type : undefined}
            value={value}
            onChange={(event: any, data: any) => this.handleInputChange(name, event, data, type)}
            onBlur={handleControlBlur}
          />
        </FormInputWithError>
        {isJsonValue && <label style={{ fontSize: 12, color: '#898d97' }}>Detected as json object</label>}
      </Grid.Column>
    </Grid.Row>);
  };
}

